import React, { useEffect, useRef } from 'react';
import propTypes from 'prop-types';
import moment from '~/Providers/Moment';

import DateHeader from './DateHeader';
import HabitsColumn from './HabitsColumn';
import './Habits.scss';
import HabitTrackingRow from './HabitTrackingRow';
import HabitContext from './HabitContext';

const MobileLayout = ({ start, habitState }) => {
  const containerRef = useRef(null);
  const secondContainerRef = useRef(null);
  const gridContainerRef = useRef(null);

  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
  const isCurrentMonthAndYear = currentYear === start.year() && currentMonth === start.month() + 1;

  const daysInMonth = moment(start).daysInMonth();
  const daysArray = Array.from({ length: daysInMonth }, (_, index) => index + 1);

  useEffect(() => {
    const handleContainerScroll = () => {
      if (secondContainerRef.current) {
        secondContainerRef.current.scrollLeft = containerRef.current.scrollLeft;
      }
    };

    const handleSecondContainerScroll = () => {
      if (containerRef.current) {
        containerRef.current.scrollLeft = secondContainerRef.current.scrollLeft;
      }
    };

    containerRef.current.addEventListener('scroll', handleContainerScroll);
    secondContainerRef.current.addEventListener('scroll', handleSecondContainerScroll);

    return () => {
      containerRef.current.removeEventListener('scroll', handleContainerScroll);
      secondContainerRef.current.removeEventListener('scroll', handleSecondContainerScroll);
    };
  }, []);

  useEffect(() => {
    if (isCurrentMonthAndYear) {
      const today = new Date().getDate();
      const dayIndex = today - 1;

      if (gridContainerRef.current) {
        const gridColumnStyle = window.getComputedStyle(gridContainerRef.current.firstChild);
        const containerWidth = parseFloat(gridColumnStyle.width);

        const initialOffset = dayIndex * containerWidth;

        if (containerRef.current && secondContainerRef.current) {
          containerRef.current.scrollLeft = initialOffset;
          secondContainerRef.current.scrollLeft = initialOffset;
        }
      }
    }
  }, [start, isCurrentMonthAndYear]);

  return (
    <div className="habit-container habit-wrapper habit-center">
      <div className="habit-sticky-header">
        <div className="habit-grid-container-center">
          <div className="habit-column-mobile">
            <div className="habit-column">HABITS</div>
          </div>
          <div ref={containerRef} className="habit-date-column-mobile-scroll-parent">
            <div className="habit-date-column-mobile">
              <DateHeader
                daysArray={daysArray}
                position="center"
                isCurrentMonthAndYear={isCurrentMonthAndYear}
                currentDate={new Date()}
                gridContainerRef={gridContainerRef}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="habit-container habit-scroll habit-center">
        <div className="habit-grid-container-center">
          <div className="habit-column-mobile">
            <HabitContext.Provider value={habitState}>
              <HabitsColumn start={start} />
            </HabitContext.Provider>
          </div>
          <div ref={secondContainerRef} className="habit-date-column-mobile-scroll-parent">
            <div className="habit-date-column-mobile">
              <HabitContext.Provider value={habitState}>
                <div className="habit-tracking-column">
                  {habitState.habitRows.map(habit => (
                    <div key={`center_${habit.id}`}>
                      <HabitTrackingRow
                        daysArray={daysArray}
                        position="center"
                        isCurrentMonthAndYear={isCurrentMonthAndYear}
                        currentDate={new Date()}
                        habit={habit}
                        start={start}
                      />
                    </div>
                  ))}
                  {habitState.placeholderRows.map((placeholder, index) => (
                    <div key={`center_placeholder_${index}`}>
                      <HabitTrackingRow
                        daysArray={daysArray}
                        position="center"
                        isCurrentMonthAndYear={isCurrentMonthAndYear}
                        currentDate={new Date()}
                        start={start}
                      />
                    </div>
                  ))}
                </div>
              </HabitContext.Provider>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

MobileLayout.propTypes = {
  start: propTypes.object,
  habitState: propTypes.object,
};

export default MobileLayout;
